import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-8cec1626"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "process-section",
    class: "process"
};
const _hoisted_2 = { class: "site-container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("header", { class: "process-header" }, [
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("p", { class: "section-kicker" }, "Cómo trabajo"),
        /*#__PURE__*/ _createElementVNode("h2", null, "Simple, de principio a fin.")
    ]),
    /*#__PURE__*/ _createElementVNode("p", null, " Siempre sabés en qué etapa está tu gestión, qué documentación falta y cuál es el próximo paso. ")
], -1));
const _hoisted_4 = { class: "timeline" };
const _hoisted_5 = { class: "timeline-marker" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'TestimonialsSection',
    setup(__props) {
        const steps = [
            {
                title: 'Contame la situación',
                description: 'Por formulario, teléfono o WhatsApp. Con la información inicial puedo entender qué necesitás.',
            },
            {
                title: 'Revisamos las opciones',
                description: 'Te explico requisitos, alternativas y próximos pasos en un lenguaje claro.',
            },
            {
                title: 'Lo resolvemos',
                description: 'Preparo la documentación, coordinamos la firma y acompaño la gestión hasta el final.',
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
                            return _createElementVNode("article", {
                                key: step.title
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("span", null, "0" + _toDisplayString(index + 1), 1)
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("h3", null, _toDisplayString(step.title), 1),
                                    _createElementVNode("p", null, _toDisplayString(step.description), 1)
                                ])
                            ]);
                        }), 64))
                    ])
                ])
            ]));
        };
    }
});
